import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'
import { useBrand } from '@/components/landing/site-provider'

interface LogoProps {
    className?: string
    kana?: boolean
}

/*
 * The Hajime logo: a vermilion hanko seal stamped with 始 ("hajime", the
 * beginning), the wordmark, and はじめ set vertically like a Japanese
 * signature. Sized entirely in em, so the font-size on className scales it.
 */
const Logo: FC<LogoProps> = ({ className, kana = true }): ReactNode => {
    const brand = useBrand()

    return (
        <span className={cn('hajime-logo', className)}>
            <span aria-hidden className='hajime-seal'>
                <span lang='ja'>始</span>
            </span>

            <span className='hajime-word'>{brand.wordmark}</span>

            {kana && (
                <span aria-hidden lang='ja' className='hajime-kana'>
                    はじめ
                </span>
            )}
        </span>
    )
}

export default Logo
